/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Permission} from "../models/permission";
import {User} from '../models/user';
import { Url_Base } from 'app/rest-constants';

@Injectable()
export class PingServerService {

  private token = null;

  constructor(
    private http: HttpClient
  ) { }

  private getUrl(): string {
    return `${Url_Base}/ping`;
  }

  public ping(): Promise<any> {
    const url = this.getUrl() + "?" + new Date().getTime();

    const mCurrentUserInfo = JSON.parse(localStorage.getItem('currentUser')) as UserInfo;
    this.token = (mCurrentUserInfo != null) ? mCurrentUserInfo.mToken : this.token;

    return this .http
      .get(url, {headers: new HttpHeaders({'Authorization': this.token})})
      .toPromise();
  }

}

class UserInfo {
  mUser: User;
  mToken: string;
  mPagePermissions: {[propKey: string]: Permission};
}

